import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPassword } from '../services/UserService';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPasswordPage() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const query = useQuery();
  const token = query.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      await resetPassword(token, newPassword);
      setMessage('Password reset successful! You can now log in.');
      // Navigate to home and open login modal
      setTimeout(() => navigate('/', { state: { openLogin: true } }), 1500);
    } catch (err) {
      setError('Failed to reset password. The link may be invalid or expired.');
    }
  };

  return (
    <div className='container' style={{ paddingTop: 24 }}>
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit} className='form' style={{ maxWidth: 420 }}>
        <input
          className='input'
          type='password'
          placeholder='New Password'
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <input
          className='input'
          type='password'
          placeholder='Confirm New Password'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button className='btn btn--primary' type='submit'>
          Reset Password
        </button>
      </form>
      {message && <p className='form-success'>{message}</p>}
      {error && <p className='form-error'>{error}</p>}
    </div>
  );
}
